import { createRipples } from 'react-ripples';

// Ripple Animation component w/ config
export const MyRipples = createRipples({
  during: 1200
});



// WEBPACK FOOTER //
// ./src/helpers/rippleAnimation.js